import React from 'react';
import { translate } from 'react-i18next';
import CBMediaQuery from '../shared/CBMediaQuery';
import { getStyle } from '../../utils/utils';
import NavbarButton from '../shared/NavbarButton';

class ChainNavbar extends React.Component {
  getActiveTab = () => {
    const url = window.location.pathname;
    if (url.includes('/parts-usage')) {
      return 'Parts usage';
    } else if (url.includes('/messages')) {
      return 'Messages';
    } else if (url.includes('/tasks')) {
      return 'Tasks';
    } else if (url.includes('/upcoming-maintenances')) {
      return 'Upcoming maintenances';
    } else if (url.includes('/invoicing')) {
      return 'Invoicing';
    } else if (url.includes('/settings')) {
      return 'Settings';
    } else if (url.includes('/vehicles')) {
      return 'Care service';
    } else {
      return 'Parts usage';
    }
  };

  render() {
    const { t, chainId, chain, userRole } = this.props;
    const hideInvoicing = chain && chain.hide_invoicing;
    const isAdminOrManager = userRole === 'admin' || userRole === 'manager';
    const activeTab = this.getActiveTab();
    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'navbarContainer')}>
            <div style={getStyle(screenSize, styles, 'buttonGroup')}>
              <NavbarButton
                to={`/chain/${chainId}/vehicles/`}
                iconSrc='/img/icon_care_service.svg'
                alt='Care service'
                buttonText={t('navChainCareServiceVehicles')}
                setActiveTab={tabName => this.setState({ activeTab: tabName })}
                activeTab={activeTab}
              />
              {isAdminOrManager && (
                <NavbarButton
                  to={`/chain/${chainId}/parts-usage/`}
                  iconSrc='/img/icon_car_checkup.svg'
                  alt='Parts usage'
                  buttonText={t('navPartsUsage')}
                  setActiveTab={tabName => this.setState({ activeTab: tabName })}
                  activeTab={activeTab}
                />
              )}
              {isAdminOrManager && (
                <NavbarButton
                  to={`/chain/${chainId}/upcoming-maintenances/`}
                  iconSrc='/img/icon_car_service.svg'
                  alt='Upcoming maintenances'
                  buttonText={t('navUpcomingMaintenances')}
                  setActiveTab={tabName => this.setState({ activeTab: tabName })}
                  activeTab={activeTab}
                />
              )}
              <NavbarButton
                to={`/chain/${chainId}/messages/`}
                iconSrc='/img/icon_messages.svg'
                alt='Messages'
                buttonText={t('navMessages')}
                setActiveTab={tabName => this.setState({ activeTab: tabName })}
                activeTab={activeTab}
              />
              <NavbarButton
                to={`/chain/${chainId}/tasks/`}
                iconSrc='/img/icon_task_list.svg'
                alt='Tasks'
                buttonText={t('navTasks')}
                setActiveTab={tabName => this.setState({ activeTab: tabName })}
                activeTab={activeTab}
              />
              {!hideInvoicing && isAdminOrManager && (
                <NavbarButton
                  to={`/chain/${chainId}/invoicing/`}
                  iconSrc='/img/icon_document.svg'
                  alt='Invoicing'
                  buttonText={t('navInvoicing')}
                  setActiveTab={tabName => this.setState({ activeTab: tabName })}
                  activeTab={activeTab}
                />
              )}
            </div>
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    navbarContainer: {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'rgba(0, 149, 218, 0.4)',
    },
    buttonGroup: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-start',
    },
    navbarButton: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRight: '1px solid #FFF',
      padding: 16,
      cursor: 'pointer',
    },
    buttonIcon: {
      display: 'inline-block',
      width: 64,
      height: 64,
    },
    buttonText: {
      display: 'inline',
      color: '#FFF',
      fontSize: 18,
    },
  },
};

export default translate('ChainHomeView')(ChainNavbar);
